import { gql } from 'apollo-boost';

export const newInvestmentMutation = gql`
  mutation newInvestmentMutation(
    $status: String,
    $portfolioId: Int!,
    $message: String,
    $cashAmount: Float,
    $goodsAmount: Float,
    $volunteerismAmount: Float,
    $servicesAmount: Float,
    $relationshipManagerId: Int,
    $tagList: String,
    $organization: String,
    $firstName: String,
    $lastName: String,
    $email: String,
    $programNameByDonor: String,
    $externalId: String,
    $granteeAccountId: Int,
    $reportDate1: Date,
    $reportDate2: Date,
    $reportDate3: Date,
    $reportDate4: Date,
    $reportDate5: Date,
    $reportDate6: Date,
    $timelineDays1: Int,
    $timelineDays2: Int,
    $timelineDays3: Int,
    $timelineDays4: Int,
    $timelineDays5: Int,
    $timelineDays6: Int,
    $timelineFrom1: String,
    $timelineFrom2: String,
    $timelineFrom3: String,
    $timelineFrom4: String,
    $timelineFrom5: String,
    $timelineFrom6: String,
  ) {
    newInvestment(
      status: $status,
      portfolioId: $portfolioId,
      message: $message,
      cashAmount: $cashAmount,
      goodsAmount: $goodsAmount,
      volunteerismAmount: $volunteerismAmount,
      servicesAmount: $servicesAmount,
      relationshipManagerId: $relationshipManagerId,
      tagList: $tagList,
      organization: $organization,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      programNameByDonor: $programNameByDonor,
      externalId: $externalId,
      granteeAccountId: $granteeAccountId,
      reportDate1: $reportDate1,
      reportDate2: $reportDate2,
      reportDate3: $reportDate3,
      reportDate4: $reportDate4,
      reportDate5: $reportDate5,
      reportDate6: $reportDate6,
      timelineDays1: $timelineDays1,
      timelineDays2: $timelineDays2,
      timelineDays3: $timelineDays3,
      timelineDays4: $timelineDays4,
      timelineDays5: $timelineDays5,
      timelineDays6: $timelineDays6,
      timelineFrom1: $timelineFrom1,
      timelineFrom2: $timelineFrom2,
      timelineFrom3: $timelineFrom3,
      timelineFrom4: $timelineFrom4,
      timelineFrom5: $timelineFrom5,
      timelineFrom6: $timelineFrom6,
    ) {
      success
      id
    }
  }
`;
